export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0,
    expeditionId: 1,
    receptionId: 2
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/' + params.path, params: params.filters }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async company ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/company', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async roles ({ dispatch, state }) {
      return dispatch('list', { basePath: 'api/rol' }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async status ({ dispatch, state }, data) {
      var params = {}
      params.type = state[data + 'Id']
      return dispatch('list', { basePath: 'api/status', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async rawReasons ({ dispatch, state }) {
      return dispatch('list', { basePath: 'api/reason' }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async reasons ({ dispatch, state }) {
      return dispatch('list', { basePath: 'api/status/related' }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/listes.js